// extracted by mini-css-extract-plugin
module.exports = {"message":"Message-module--message--1OoM-","messageError":"Message-module--message--error--3LpjJ"};